import { deriveScenesFromBody, type DerivedScene } from '@/features/studio/script/derive-scenes'
import { findSceneRangeInBody } from '@/features/studio/script/element-body-range'
import type { ScriptConvention } from '@/features/studio/script/useScriptFormatPrefs'

export function isDerivedSceneEmpty(scene: DerivedScene): boolean {
  const heading = scene.heading.trim()
  const rest = scene.body.replace(heading, '').trim()
  return rest === ''
}

export function defaultNextSceneHeading(sceneNo: number, convention: ScriptConvention): string {
  return convention === 'hollywood' ? 'INT. LOCATION - DAY' : `内景 场景${sceneNo} 日`
}

export function startsWithSceneHeading(text: string, convention: ScriptConvention): boolean {
  const first = text.trim().split('\n')[0]?.trim() ?? ''
  if (!first) return false
  return deriveScenesFromBody(`${first}\n\n动作。`, convention).length > 0
}

/** 把续写结果追加为新场；若最后一场是空标题则填进该空场。 */
export function appendWriterNextScene(
  body: string,
  generated: string,
  convention: ScriptConvention,
): { nextBody: string; sceneNo: number } {
  const chunk = generated.trim()
  const scenes = deriveScenesFromBody(body, convention)
  const last = scenes[scenes.length - 1]
  const fillEmpty = !!last && isDerivedSceneEmpty(last)
  const sceneNo = fillEmpty && last ? last.scene_no : last ? last.scene_no + 1 : 1
  const headed = startsWithSceneHeading(chunk, convention)
    ? chunk
    : `${defaultNextSceneHeading(sceneNo, convention)}\n\n${chunk}`

  if (fillEmpty && last) {
    const range = findSceneRangeInBody(
      body,
      scenes.map((s) => ({ scene_no: s.scene_no, heading: s.heading, body: s.body })),
      last.scene_no,
      convention,
    )
    if (range) {
      return { nextBody: `${body.slice(0, range.start)}${headed}${body.slice(range.end)}`, sceneNo }
    }
  }

  const nextBody = body.trim() ? `${body.trimEnd()}\n\n${headed}` : headed
  return { nextBody, sceneNo }
}
